import { render, staticRenderFns } from "./LoadFund.vue?vue&type=template&id=ac55e66e&scoped=true"
import script from "./LoadFund.vue?vue&type=script&lang=js"
export * from "./LoadFund.vue?vue&type=script&lang=js"
import style0 from "./LoadFund.vue?vue&type=style&index=0&id=ac55e66e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac55e66e",
  null
  
)

export default component.exports